import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstanceeghlbkcb6su6 as Companion_getInstance,
  Angle36m0cdko0c63j as Angle,
  Angle__toString_impl_786qky3amgxlk310y0l as Angle__toString_impl_786qky,
  Angle__hashCode_impl_szcndt7z0bvq6vi9u2 as Angle__hashCode_impl_szcndt,
  _Angle___init__impl__g23q1mpxbjdjfwrarw as _Angle___init__impl__g23q1m,
} from './Angle.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  zipWithNext1coaflhq3atps as zipWithNext,
  sum21i2pabt6cxsw as sum,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { coerceIn10f36k81le1mm as coerceIn } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { toInt5qdj874w69jh as toInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { _UInt___init__impl__l7qpdltd1eeof8nsuj as _UInt___init__impl__l7qpdl } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { toString10m9tj9xt75j5 as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { padStart36w1507hs626a as padStart } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { drop336950s126lmj as drop } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp.tcy_1 = new (LinearGradient())(tmp$ret$0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function LinearGradient$closestColor$lambda(a, b) {
  return (b.faz_1 - a.faz_1) * (a.gaz_1.haz_1 + b.gaz_1.haz_1) / 2;
}
function LinearGradient$closestColor$lambda_0(a, b) {
  return (b.faz_1 - a.faz_1) * (a.gaz_1.iaz_1 + b.gaz_1.iaz_1) / 2;
}
function LinearGradient$closestColor$lambda_1(a, b) {
  return (b.faz_1 - a.faz_1) * (a.gaz_1.jaz_1 + b.gaz_1.jaz_1) / 2;
}
function LinearGradient$closestColor$lambda_2(a, b) {
  return (b.faz_1 - a.faz_1) * (a.gaz_1.kaz_1 + b.gaz_1.kaz_1) / 2;
}
var LinearGradientClass;
function LinearGradient() {
  if (LinearGradientClass === VOID) {
    class $ {
      constructor(stops, angle, screenStatic) {
        Companion_getInstance_0();
        angle = angle === VOID ? Companion_getInstance().eb2_1 : angle;
        screenStatic = screenStatic === VOID ? false : screenStatic;
        this.maz_1 = stops;
        this.naz_1 = angle;
        this.oaz_1 = screenStatic;
      }
      ucy(mapper) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.maz_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = mapper(item.gaz_1);
          var tmp$ret$1 = item.vcy(VOID, tmp$ret$0);
          destination.v(tmp$ret$1);
        }
        return this.wcy(destination);
      }
      bb2() {
        if (this.maz_1.i1())
          return Companion_getInstance_1().qaz_1;
        if (this.maz_1.p1() === 1)
          return this.maz_1.q1(0).gaz_1;
        var tmp = asSequence(this.maz_1);
        var tmp_0 = sum(zipWithNext(tmp, LinearGradient$closestColor$lambda));
        var tmp_1 = asSequence(this.maz_1);
        var tmp_2 = sum(zipWithNext(tmp_1, LinearGradient$closestColor$lambda_0));
        var tmp_3 = asSequence(this.maz_1);
        var tmp_4 = sum(zipWithNext(tmp_3, LinearGradient$closestColor$lambda_1));
        var tmp_5 = asSequence(this.maz_1);
        return new (Color())(tmp_0, tmp_2, tmp_4, sum(zipWithNext(tmp_5, LinearGradient$closestColor$lambda_2)));
      }
      xcy(stops, angle, screenStatic) {
        return new (LinearGradient())(stops, angle, screenStatic);
      }
      wcy(stops, angle, screenStatic, $super) {
        stops = stops === VOID ? this.maz_1 : stops;
        angle = angle === VOID ? this.naz_1 : angle;
        screenStatic = screenStatic === VOID ? this.oaz_1 : screenStatic;
        return $super === VOID ? this.xcy(stops, angle, screenStatic) : $super.xcy.call(this, stops, new (Angle())(angle), screenStatic);
      }
      toString() {
        return 'LinearGradient(stops=' + toString(this.maz_1) + ', angle=' + Angle__toString_impl_786qky(this.naz_1) + ', screenStatic=' + this.oaz_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.maz_1);
        result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.naz_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.oaz_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LinearGradient()))
          return false;
        if (!equals(this.maz_1, other.maz_1))
          return false;
        if (!equals(this.naz_1, other.naz_1))
          return false;
        if (!(this.oaz_1 === other.oaz_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LinearGradient');
    LinearGradientClass = $;
  }
  return LinearGradientClass;
}
function byteize($this, _this__u8e3s4) {
  return coerceIn(numberToInt(_this__u8e3s4 * 255), 0, 255);
}
function floatize($this, _this__u8e3s4) {
  return coerceIn(_this__u8e3s4, 0, 255) / 255;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.qaz_1 = new (Color())();
        this.raz_1 = new (Color())(1.0, 1.0, 1.0, 1.0);
        this.saz_1 = new (Color())(1.0, 0.5, 0.5, 0.5);
        this.taz_1 = new (Color())(1.0, 0.0, 0.0, 0.0);
        this.uaz_1 = new (Color())(1.0, 1.0, 0.0, 0.0);
        this.vaz_1 = new (Color())(1.0, 1.0, 0.5, 0.0);
        this.waz_1 = new (Color())(1.0, 1.0, 1.0, 0.0);
        this.xaz_1 = new (Color())(1.0, 0.0, 1.0, 0.0);
        this.yaz_1 = new (Color())(1.0, 0.0, 1.0, 1.0);
        this.zaz_1 = new (Color())(1.0, 0.0, 0.0, 1.0);
        this.ab0_1 = new (Color())(1.0, 1.0, 0.0, 1.0);
      }
      ycy(amount) {
        return new (Color())(1.0, amount, amount, amount);
      }
      zcy(value) {
        return new (Color())(1.0, floatize(this, value >> 16 & 255), floatize(this, value >> 8 & 255), floatize(this, value & 255));
      }
      acz(value) {
        return this.zcy(toInt(replace(value, '#', ''), 16));
      }
      bcz(left, right, ratio) {
        var invRatio = 1 - ratio;
        return new (Color())(left.haz_1 * invRatio + right.haz_1 * ratio, left.iaz_1 * invRatio + right.iaz_1 * ratio, left.jaz_1 * invRatio + right.jaz_1 * ratio, left.kaz_1 * invRatio + right.kaz_1 * ratio);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var ColorClass;
function Color() {
  if (ColorClass === VOID) {
    class $ {
      constructor(alpha, red, green, blue) {
        Companion_getInstance_1();
        alpha = alpha === VOID ? 0.0 : alpha;
        red = red === VOID ? 0.0 : red;
        green = green === VOID ? 0.0 : green;
        blue = blue === VOID ? 0.0 : blue;
        this.haz_1 = alpha;
        this.iaz_1 = red;
        this.jaz_1 = green;
        this.kaz_1 = blue;
      }
      ucy(mapper) {
        // Inline function 'kotlin.let' call
        return mapper(this);
      }
      bb2() {
        return this;
      }
      ccz(alpha) {
        return this.dcz(alpha * this.haz_1);
      }
      ecz() {
        return byteize(Companion_getInstance_1(), this.haz_1) << 24 | byteize(Companion_getInstance_1(), this.iaz_1) << 16 | byteize(Companion_getInstance_1(), this.jaz_1) << 8 | byteize(Companion_getInstance_1(), this.kaz_1);
      }
      fcz(ratio) {
        return this.dcz(VOID, this.iaz_1 * (1.0 - ratio), this.jaz_1 * (1.0 - ratio), this.kaz_1 * (1.0 - ratio));
      }
      gcz(ratio) {
        return this.dcz(VOID, this.iaz_1 + (1.0 - this.iaz_1) * ratio, this.jaz_1 + (1.0 - this.jaz_1) * ratio, this.kaz_1 + (1.0 - this.kaz_1) * ratio);
      }
      hcz(alpha) {
        return this.dcz(alpha);
      }
      icz() {
        return (this.iaz_1 + this.jaz_1 + this.kaz_1) / 3.0;
      }
      zb2() {
        // Inline function 'kotlin.math.sqrt' call
        var x = this.iaz_1 * this.iaz_1 * 0.299 + this.jaz_1 * this.jaz_1 * 0.587 + this.kaz_1 * this.kaz_1 * 0.114;
        return Math.sqrt(x);
      }
      jcz() {
        return byteize(Companion_getInstance_1(), this.iaz_1);
      }
      kcz() {
        return byteize(Companion_getInstance_1(), this.jaz_1);
      }
      lcz() {
        return byteize(Companion_getInstance_1(), this.kaz_1);
      }
      mcz(ratio) {
        return Companion_getInstance_1().bcz(this, Companion_getInstance_1().raz_1, ratio);
      }
      ncz(ratio) {
        return Companion_getInstance_1().bcz(this, Companion_getInstance_1().taz_1, ratio);
      }
      ocz(ratio) {
        return this.icz() > 0.5 ? this.ncz(ratio) : this.mcz(ratio);
      }
      pcz() {
        var tmp;
        if (this.iaz_1 > this.jaz_1 && this.iaz_1 > this.kaz_1) {
          var tmp_0 = this.jaz_1 - this.kaz_1;
          var tmp0 = this.iaz_1;
          // Inline function 'kotlin.math.max' call
          var b = this.jaz_1;
          var tmp0_0 = Math.max(tmp0, b);
          // Inline function 'kotlin.math.max' call
          var b_0 = this.kaz_1;
          var tmp_1 = Math.max(tmp0_0, b_0);
          var tmp0_1 = this.iaz_1;
          // Inline function 'kotlin.math.min' call
          var b_1 = this.jaz_1;
          var tmp0_2 = Math.min(tmp0_1, b_1);
          // Inline function 'kotlin.math.min' call
          var b_2 = this.kaz_1;
          tmp = tmp_0 / (tmp_1 - Math.min(tmp0_2, b_2));
        } else if (this.jaz_1 > this.iaz_1 && this.jaz_1 > this.kaz_1) {
          var tmp_2 = this.kaz_1 - this.iaz_1;
          var tmp0_3 = this.iaz_1;
          // Inline function 'kotlin.math.max' call
          var b_3 = this.jaz_1;
          var tmp0_4 = Math.max(tmp0_3, b_3);
          // Inline function 'kotlin.math.max' call
          var b_4 = this.kaz_1;
          var tmp_3 = Math.max(tmp0_4, b_4);
          var tmp0_5 = this.iaz_1;
          // Inline function 'kotlin.math.min' call
          var b_5 = this.jaz_1;
          var tmp0_6 = Math.min(tmp0_5, b_5);
          // Inline function 'kotlin.math.min' call
          var b_6 = this.kaz_1;
          tmp = tmp_2 / (tmp_3 - Math.min(tmp0_6, b_6)) + 2;
        } else if (this.kaz_1 > this.jaz_1 && this.kaz_1 > this.iaz_1) {
          var tmp_4 = this.iaz_1 - this.jaz_1;
          var tmp0_7 = this.iaz_1;
          // Inline function 'kotlin.math.max' call
          var b_7 = this.jaz_1;
          var tmp0_8 = Math.max(tmp0_7, b_7);
          // Inline function 'kotlin.math.max' call
          var b_8 = this.kaz_1;
          var tmp_5 = Math.max(tmp0_8, b_8);
          var tmp0_9 = this.iaz_1;
          // Inline function 'kotlin.math.min' call
          var b_9 = this.jaz_1;
          var tmp0_10 = Math.min(tmp0_9, b_9);
          // Inline function 'kotlin.math.min' call
          var b_10 = this.kaz_1;
          tmp = tmp_4 / (tmp_5 - Math.min(tmp0_10, b_10)) + 4;
        } else {
          tmp = 0.0;
        }
        // Inline function 'kotlin.let' call
        var it = tmp;
        var tmp_6 = _Angle___init__impl__g23q1m((it + 6.0) % 6.0 / 6.0);
        // Inline function 'kotlin.run' call
        var tmp0_11 = this.iaz_1;
        // Inline function 'kotlin.math.min' call
        var b_11 = this.jaz_1;
        var tmp0_12 = Math.min(tmp0_11, b_11);
        // Inline function 'kotlin.math.min' call
        var b_12 = this.kaz_1;
        var min = Math.min(tmp0_12, b_12);
        var tmp0_13 = this.iaz_1;
        // Inline function 'kotlin.math.max' call
        var b_13 = this.jaz_1;
        var tmp0_14 = Math.max(tmp0_13, b_13);
        // Inline function 'kotlin.math.max' call
        var b_14 = this.kaz_1;
        var max = Math.max(tmp0_14, b_14);
        var tmp$ret$19 = max === 0.0 ? 0.0 : (max - min) / max;
        return new (HSPColor())(this.haz_1, tmp_6, tmp$ret$19, this.zb2());
      }
      paz() {
        return 'rgba(' + this.jcz() + ', ' + this.kcz() + ', ' + this.lcz() + ', ' + this.haz_1 + ')';
      }
      laz() {
        // Inline function 'kotlin.toUInt' call
        var this_0 = this.ecz();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        return '#' + drop(padStart(toString_0(tmp$ret$0, 16), 8, _Char___init__impl__6a9atx(48)), 2);
      }
      qcz(alpha, red, green, blue) {
        return new (Color())(alpha, red, green, blue);
      }
      dcz(alpha, red, green, blue, $super) {
        alpha = alpha === VOID ? this.haz_1 : alpha;
        red = red === VOID ? this.iaz_1 : red;
        green = green === VOID ? this.jaz_1 : green;
        blue = blue === VOID ? this.kaz_1 : blue;
        return $super === VOID ? this.qcz(alpha, red, green, blue) : $super.qcz.call(this, alpha, red, green, blue);
      }
      toString() {
        return 'Color(alpha=' + this.haz_1 + ', red=' + this.iaz_1 + ', green=' + this.jaz_1 + ', blue=' + this.kaz_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.haz_1);
        result = imul(result, 31) + getNumberHashCode(this.iaz_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.jaz_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.kaz_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Color()))
          return false;
        if (!equals(this.haz_1, other.haz_1))
          return false;
        if (!equals(this.iaz_1, other.iaz_1))
          return false;
        if (!equals(this.jaz_1, other.jaz_1))
          return false;
        if (!equals(this.kaz_1, other.kaz_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Color', Color);
    ColorClass = $;
  }
  return ColorClass;
}
function applyAlpha(_this__u8e3s4, alpha) {
  return _this__u8e3s4.ucy((it) => it.ccz(alpha));
}
var GradientStopClass;
function GradientStop() {
  if (GradientStopClass === VOID) {
    class $ {
      constructor(ratio, color) {
        this.faz_1 = ratio;
        this.gaz_1 = color;
      }
      rcz(ratio, color) {
        return new (GradientStop())(ratio, color);
      }
      vcy(ratio, color, $super) {
        ratio = ratio === VOID ? this.faz_1 : ratio;
        color = color === VOID ? this.gaz_1 : color;
        return $super === VOID ? this.rcz(ratio, color) : $super.rcz.call(this, ratio, color);
      }
      toString() {
        return 'GradientStop(ratio=' + this.faz_1 + ', color=' + this.gaz_1.toString() + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.faz_1);
        result = imul(result, 31) + this.gaz_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GradientStop()))
          return false;
        if (!equals(this.faz_1, other.faz_1))
          return false;
        if (!this.gaz_1.equals(other.gaz_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GradientStop');
    GradientStopClass = $;
  }
  return GradientStopClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        this.scz_1 = 0.299;
        this.tcz_1 = 0.587;
        this.ucz_1 = 0.114;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var HSPColorClass;
function HSPColor() {
  if (HSPColorClass === VOID) {
    class $ {
      constructor(alpha, hue, saturation, brightness) {
        alpha = alpha === VOID ? 1.0 : alpha;
        hue = hue === VOID ? _Angle___init__impl__g23q1m(0.0) : hue;
        saturation = saturation === VOID ? 0.0 : saturation;
        brightness = brightness === VOID ? 0.0 : brightness;
        this.vcz_1 = alpha;
        this.wcz_1 = hue;
        this.xcz_1 = saturation;
        this.ycz_1 = brightness;
      }
      toString() {
        return 'HSPColor(alpha=' + this.vcz_1 + ', hue=' + Angle__toString_impl_786qky(this.wcz_1) + ', saturation=' + this.xcz_1 + ', brightness=' + this.ycz_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.vcz_1);
        result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.wcz_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.xcz_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.ycz_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HSPColor()))
          return false;
        if (!equals(this.vcz_1, other.vcz_1))
          return false;
        if (!equals(this.wcz_1, other.wcz_1))
          return false;
        if (!equals(this.xcz_1, other.xcz_1))
          return false;
        if (!equals(this.ycz_1, other.ycz_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HSPColor', HSPColor);
    HSPColorClass = $;
  }
  return HSPColorClass;
}
function RadialGradient$closestColor$lambda(a, b) {
  return (b.faz_1 - a.faz_1) * (a.gaz_1.haz_1 + b.gaz_1.haz_1) / 2;
}
function RadialGradient$closestColor$lambda_0(a, b) {
  return (b.faz_1 - a.faz_1) * (a.gaz_1.iaz_1 + b.gaz_1.iaz_1) / 2;
}
function RadialGradient$closestColor$lambda_1(a, b) {
  return (b.faz_1 - a.faz_1) * (a.gaz_1.jaz_1 + b.gaz_1.jaz_1) / 2;
}
function RadialGradient$closestColor$lambda_2(a, b) {
  return (b.faz_1 - a.faz_1) * (a.gaz_1.kaz_1 + b.gaz_1.kaz_1) / 2;
}
var RadialGradientClass;
function RadialGradient() {
  if (RadialGradientClass === VOID) {
    class $ {
      bb2() {
        if (this.daz_1.i1())
          return Companion_getInstance_1().qaz_1;
        if (this.daz_1.p1() === 1)
          return this.daz_1.q1(0).gaz_1;
        var tmp = asSequence(this.daz_1);
        var tmp_0 = sum(zipWithNext(tmp, RadialGradient$closestColor$lambda));
        var tmp_1 = asSequence(this.daz_1);
        var tmp_2 = sum(zipWithNext(tmp_1, RadialGradient$closestColor$lambda_0));
        var tmp_3 = asSequence(this.daz_1);
        var tmp_4 = sum(zipWithNext(tmp_3, RadialGradient$closestColor$lambda_1));
        var tmp_5 = asSequence(this.daz_1);
        return new (Color())(tmp_0, tmp_2, tmp_4, sum(zipWithNext(tmp_5, RadialGradient$closestColor$lambda_2)));
      }
    }
    initMetadataForClass($, 'RadialGradient');
    RadialGradientClass = $;
  }
  return RadialGradientClass;
}
var FadingColorClass;
function FadingColor() {
  if (FadingColorClass === VOID) {
    class $ {
      constructor(base, alternate) {
        this.bb0_1 = base;
        this.cb0_1 = alternate;
      }
      bb2() {
        return this.bb0_1;
      }
      ucy(mapper) {
        return new (FadingColor())(mapper(this.bb0_1), mapper(this.cb0_1));
      }
      toString() {
        return 'FadingColor(base=' + this.bb0_1.toString() + ', alternate=' + this.cb0_1.toString() + ')';
      }
      hashCode() {
        var result = this.bb0_1.hashCode();
        result = imul(result, 31) + this.cb0_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FadingColor()))
          return false;
        if (!this.bb0_1.equals(other.bb0_1))
          return false;
        if (!this.cb0_1.equals(other.cb0_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'FadingColor');
    FadingColorClass = $;
  }
  return FadingColorClass;
}
function darken(_this__u8e3s4, ratio) {
  return _this__u8e3s4.ucy((it) => it.fcz(ratio));
}
//region block: init
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Color as Color17ck47lkedxoy,
  FadingColor as FadingColor3d6ef6zcqmlhk,
  LinearGradient as LinearGradient2qftccjwl6uey,
  RadialGradient as RadialGradient3ic79yys0k1fp,
  applyAlpha as applyAlpha3k2fcxahu1lgz,
  darken as darken120sc580p6xj9,
  Companion_getInstance_1 as Companion_getInstancenv8qpb0wanrh,
  Companion_getInstance_0 as Companion_getInstance344l9hiw99vvc,
};
//endregion

//# sourceMappingURL=Paint.mjs.map
